import { COLLECTION, CONVERSATION, GROUP, REPORTS, STREAM, ASSET, CONTENT_MAP, SEARCH } from 'src/constants/adoption/sourceTypes';
import mixpanel from 'mixpanel-browser';
import { mixPanel } from '../config';

export default class EventService {
  static initialiseMixpanel(){
    mixpanel.init(mixPanel.appId);
  }

  static getMixpanelDistinctId() {
    return mixpanel.get_distinct_id();
  }

  static trackEvent(name, props) {
    mixpanel.track(name, props);
  }
   
  static getExperienceType(key) {
    let experienceType = "";

    switch (key) {
        case "MASONRY":
            experienceType = "Metro";
            break;
        case "CAROUSEL":
            experienceType = "Carousel";
            break;
        case "DEAL_ROOM":
            experienceType = "Deal Room";
            break;
        default:
            experienceType = "";
            break;
    }

    return experienceType;
}


  static getViewerType(key) {
    let viewerType = "";

    switch (key) {
      case "LIST_VIEWER":
        viewerType = "List";
        break;
      case "IMMERSE_VIEWER":
        viewerType = "Immerse";
        break;
      case "GALLERY_VIEWER":
        viewerType = "Gallery";
        break;
      default:
        viewerType = "";
        break;
    }

    return viewerType;
  }

  static getSourceType(key) {

    var sourceType = "";
    switch (key) {
      case "gdrive":
        sourceType = "Google Drive";
        break;

      case "onedrive":
        sourceType = "OneDrive";
        break;

      case "sharepoint":
        sourceType = "SharePoint";
        break;
      
      case "dropbox":
        sourceType = "Dropbox";
        break;
      
      case "box":
        sourceType = "Box";
        break;
      
      default:
        // sourceType = _.capitalize(sourceType);
        break;
    }

    return sourceType;
  }


  static getSourceCta(key) {

    var sourceCta = "";
    switch (key) {
      case "streams":
        sourceCta = STREAM;
        break;

      case "groups":
        sourceCta = GROUP;
        break;

      case "collections":
        sourceCta = COLLECTION;
        break;

      case "conversations":
        sourceCta = CONVERSATION;
        break;

      case "reports":
        sourceCta = REPORTS;
        break;
      
      case "asset":
        sourceCta = ASSET;
        break;

      case "hub":
        sourceCta = CONTENT_MAP;
        break;

      case "search":
        sourceCta = SEARCH;
        break;
        
      default:
        sourceCta = "Content Hub";
        break;
    }

    return sourceCta;
  }

  static getSourceNameType(key){
    var sourceNameType = "";

    switch (key) {
      case "Stream":
        sourceNameType = "stream_name";
        break;
      
      case "Group":
        sourceNameType = "group_name";
        break;
      
      case "Collection":
        sourceNameType = "collection_name";
        break;
      
      default:
        sourceNameType = "source_name";
        break;
    }
    
    return sourceNameType;
  }

  static getLegendName(key){
    var mapFilterName = "";

    switch (key) {
      case "all":
        mapFilterName = "My Recipients";
        break;
      case "live":
        mapFilterName = "Live Users";
        break;
      case "unread":
        mapFilterName = "Unread Chats";
        break;
      default:
        mapFilterName = "";
        break;
    }

    return mapFilterName;
  }

  static getMapFilterName(key){
    var legendName = "";

    switch (key) {
      case "all":
        legendName = "All";
        break;
      case "live":
        legendName = "Live";
        break;
      case "last24Hours":
        legendName = "Last 24 Hours";
        break;
      case "lastWeek":
        legendName = "Last 7 Days";
        break;
      default:
        legendName = "";
        break;
    }

    return legendName;
  }

  static shouldBackToSource(source){
    switch(source){
      case "weeklyDigest": 
      case "dailyDigest":
      case "chrome_extension": 
      case "hubspot":
      case "salesforce":
      case "":  
        return false;
      default:
        return true;
    }

  }

  static triggerEventForSource(source){
    switch(source){
      case "chrome_extension":
      case "hubspot": 
      case "salesforce":
        return false;
      default:
        return true;
    }
  }
}
